/**
 * Every declaration module. Importing this file registers every permission (the barrel imports it).
 * Each module is also re-exported as a namespace so callers reference a declared node, never a string:
 * `Maintenance.employeesActivate.permission`.
 *
 * ES modules evaluate their imports first, so by the time this module's body runs every declaration
 * below has registered; it then seals the registry (`registry.ts`).
 */
import { seal } from '../registry';

export * as Admin from './admin';
export * as Cli from './cli';
export * as Feedback from './feedback';
export * as ClientOptions from './client-options';
export * as Maintenance from './maintenance';
export * as ReportViews from './report-views';
export * as Reports from './reports';
export * as VaultManagement from './vault-management';
export * as DataSecurity from './data-security';

seal();
